import { render, staticRenderFns } from "./Acompanha_Denuncia.vue?vue&type=template&id=5ec80943&scoped=true&"
import script from "./Acompanha_Denuncia.vue?vue&type=script&lang=js&"
export * from "./Acompanha_Denuncia.vue?vue&type=script&lang=js&"
import style0 from "./Acompanha_Denuncia.vue?vue&type=style&index=0&id=5ec80943&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec80943",
  null
  
)

export default component.exports